import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, euro } from "@/lib/api";
import { isDue } from "@/components/admin/CoachingFollowUp";

const Kpi = ({ label, value, hint, testid, accent }) => (
  <div className={`border p-5 ${accent ? "border-[#98bfa2] bg-[#98bfa2] text-[#050807]" : "border-[rgba(152,191,162,0.15)] bg-[#0b120e]"}`}>
    <p className={`font-mono text-[11px] uppercase tracking-widest ${accent ? "" : "text-[#a3b1aa]"}`}>{label}</p>
    <p data-testid={testid} className="mt-2 font-display text-4xl font-900 leading-none">{value}</p>
    {hint && <p className={`mt-2 text-xs ${accent ? "text-[#050807]/75" : "text-[#a3b1aa]"}`}>{hint}</p>}
  </div>
);

const ListCard = ({ title, to, empty, rows, testid }) => (
  <div className="border border-[rgba(152,191,162,0.15)] bg-[#0b120e]" data-testid={testid}>
    <div className="flex items-center justify-between border-b border-white/5 px-5 py-4">
      <p className="font-mono text-xs uppercase tracking-widest text-[#98bfa2]">{title}</p>
      <Link to={to} className="font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa] underline hover:text-[#c4dcca]">Vedi tutti</Link>
    </div>
    {rows.length === 0 ? <p className="px-5 py-6 text-sm text-[#a3b1aa]">{empty}</p> : (
      <div className="divide-y divide-white/5">
        {rows.map(([key, left, right]) => (
          <div key={key} className="flex items-center justify-between gap-3 px-5 py-3 text-sm">
            <span className="min-w-0 truncate">{left}</span><span className="shrink-0 font-mono text-xs text-[#a3b1aa]">{right}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

const day = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "");

export const DashboardHome = () => {
  const [contacts, setContacts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/coaching-checkups").then((r) => setContacts(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    api.get("/admin/orders").then((r) => setOrders(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  const paid = orders.filter((o) => o.payment_status === "paid");
  const coachingRev = paid.filter((o) => o.kind === "coaching").reduce((t, o) => t + (o.amount || 0), 0);
  const guidesRev = paid.filter((o) => o.kind !== "coaching").reduce((t, o) => t + (o.amount || 0), 0);
  const due = contacts.filter(isDue);
  const fresh = contacts.filter((c) => c.status === "da_chiamare" && c.pay_status !== "pagato");
  const waiting = contacts.filter((c) => c.pay_status === "invitato");

  return (
    <div className="space-y-8" data-testid="admin-home">
      <div className="grid grid-cols-2 gap-3 xl:grid-cols-3">
        <Kpi accent label="Posti occupati" value={s ? `${s.seats_taken}/${s.coaching_seats}` : "—"} hint={s ? `${s.seats_left} liberi nel percorso attuale` : ""} testid="kpi-seats" />
        <Kpi label="Da richiamare oggi" value={due.length} hint="Inclusi i richiami scaduti" testid="kpi-due" />
        <Kpi label="Nuovi contatti" value={fresh.length} hint="Stato «Da chiamare»" testid="kpi-new" />
        <Kpi label="In attesa di pagamento" value={waiting.length} hint="Link inviato, non ancora pagato" testid="kpi-waiting" />
        <Kpi label="Incasso training" value={euro(coachingRev)} testid="kpi-coaching-revenue" />
        <Kpi label="Incasso guide" value={euro(guidesRev)} testid="kpi-guides-revenue" />
      </div>
      <div className="grid gap-4 xl:grid-cols-3">
        <ListCard testid="home-due-list" title="Da richiamare oggi" to="/admin/contatti" empty="Nessun richiamo per oggi."
          rows={due.map((c) => [c.id, c.name, c.phone])} />
        <ListCard testid="home-latest-contacts" title="Ultimi contatti" to="/admin/contatti" empty="Nessun contatto ancora."
          rows={contacts.slice(0, 5).map((c) => [c.id, c.name, `${c.score ?? 0}/100 · ${day(c.created_at)}`])} />
        <ListCard testid="home-latest-orders" title="Ultimi pagamenti" to="/admin/ordini" empty="Nessun pagamento ancora."
          rows={paid.slice(0, 5).map((o) => [o.session_id, o.label || (o.items || []).map((i) => i.name).join(", "), euro(o.amount)])} />
      </div>
    </div>
  );
};
